<template>
  <div class="p-4 flex flex-col gap-y-2.5">
    <div class="w-full">
      <p>
        <span class="text-brand-black-body text-xs ltr:font-sans">
          {{ $t('serviceTransactions') }}:
        </span>
        <span class="ps-1.5">{{ requestEntity.serviceTransactionName }}</span>
      </p>
    </div>
    <div class="w-full flex flex-wrap justify-between gap-y-2.5">
      <div class="w-1/2 flex flex-col md:flex-row items-start md:items-center">
        <span class="text-brand-black-body text-xs ltr:font-sans">{{ $t('requestNumber') }}:</span>
        <span class="md:ps-1.5">{{ requestEntity.requestNumber }}</span>
      </div>
      <div v-if="requestEntity.pranNumber" class="w-1/2">
        <span class="text-brand-black-body text-xs ltr:font-sans">{{ $t('pran') }}:</span>
        <span class="md:ps-1.5">{{ requestEntity.pranNumber }}</span>
      </div>
      <div class="w-1/2 flex flex-col md:flex-row items-start md:items-center">
        <span class="text-brand-black-body text-xs ltr:font-sans">
          {{ $t('administration') }}:
        </span>
        <span class="md:ps-1.5">{{ requestEntity.admninstrativeRegions.text }}</span>
      </div>
      <div class="w-1/2 flex flex-col md:flex-row items-start md:items-center">
        <span class="text-brand-black-body text-xs ltr:font-sans">
          {{ $t('receiptNumber') }}:
        </span>
        <span class="md:ps-1.5">{{ requestEntity.receiptNumber }}</span>
      </div>
      <div class="w-1/2 flex flex-col md:flex-row items-start md:items-center">
        <span class="text-brand-black-body text-xs ltr:font-sans">
          {{ $t('applicationFees') }}:
        </span>
        <span class="md:ps-1.5">{{ intlNumberFormat.format(requestEntity.paidAmount) }}</span>
      </div>
      <div class="w-1/2 flex flex-col md:flex-row items-start md:items-center">
        <span class="text-brand-black-body text-xs ltr:font-sans"> {{ $t('requestDate') }}: </span>
        <span class="md:ps-1.5">{{ requestDatePretty }}</span>
      </div>
    </div>

    <DataTable :data-set="dataSet">
      <template #cell="{ rowIndex, columnName }">
        <div v-if="columnName == 'actionComment'" class="w-full flex justify-center">
          <RouterLink
            v-if="applicationHistory[rowIndex].action.id == 64"
            :to="{
              name: 'TODOgoToVirtualMeetingDetails',
              query: {
                requestNumber: requestEntity.requestNumber
              }
            }"
            class="px-3 py-0.5 text-center rounded-md bg-primary/80 hover:bg-primary flex items-start md:items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
          >
            {{ $t('showVirtualMeetingDetails') }}
          </RouterLink>
          <p v-else v-html="applicationHistory[rowIndex].actionComment"></p>
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script setup>
import DataTable from '@/components/DataTable/index.vue'
import { computed } from 'vue'
import { DateTime } from 'luxon'

const intlNumberFormat = Intl.NumberFormat('AE-en', { style: 'currency', currency: 'AED' })

const props = defineProps({
  result: Object
})

const { requestEntity, applicationHistory } = props.result

const requestDatePretty = computed(() => {
  return DateTime.fromISO(requestEntity.requestDate).toFormat('dd/MM/yyyy HH:mm:ss a')
})

const dataSet = computed(() => {
  if ((applicationHistory ?? []).length === 0) return

  return applicationHistory.map((a) => {
    return {
      requestActions: a.action.text,
      transactionDate: DateTime.fromISO(a.date).toFormat('dd/MM/yyyy HH:mm:ss a'),
      actionComment: ''
    }
  })
})
</script>

<style lang="scss" scoped></style>
